export default __webpack_public_path__ + "static/media/skate.ec15e72d.png";